<!-- start of new editor -->
<template>
  <div
    id="page-container"
    class="enable-page-overlay side-scroll main-content-boxed"
  >
    <header-component></header-component>
    <sidebar-component></sidebar-component>
    <main id="main-container">
      <div class="bg-body-light border-top border-bottom">
        <div class="content content-full py-1">
          <div
            class="d-flex flex-column flex-sm-row justify-content-sm-between align-items-sm-center"
          >
            <main id="main-container">
              <div class="content">
                <div class="row">
                  <div class="mt-3 mb-3">
                    <div class="input-group-prepend">
                      <multiselect
                        :id="'multiselect'"
                        v-model="selectedForms"
                        placeholder="Search Forms..."
                        label="name"
                        track-by="id"
                        :options="searchForms"
                        :multiple="true"
                        :options-limit="50000"
                        :searchable="isSearchable"
                        style="z-index: 120"
                        @search-change="handleFormSearch"
                        @select="handleOnSelect"
                        :clear-on-select="false"
                        :loading="isLoading"
                        :block-keys="['Delete', 'Enter']"
                      >
                      </multiselect>
                    </div>
                    <!-- <div>
                     <button
                      type="button"
                      class="btn btn-outline-primary"
                      style="width: 205px;"
                    >
                      Search
                    </button>
                   </div> -->
                  </div>
                  <div
                    class="block block-bordered col-md-12"
                    style="background-color: #e6f5ff"
                  >
                    <div
                      class="block-header block-header-default"
                      style="background-color: #e6f5ff"
                    >
                      <h3 class="block-title">Connections</h3>
                      <button
                        type="button"
                        data-toggle="modal"
                        data-target="#modal-block-add-product-form-manager"
                        class="btn btn-outline-primary"
                        style="font-size: 10px"
                      >
                        Add Connections
                      </button>
                      <div class="block-options">
                        <button
                          type="button"
                          class="btn-block-option"
                          data-toggle="block-option"
                          data-action="content_toggle"
                        >
                          <i class="si si-arrow-down"></i>
                        </button>
                      </div>
                    </div>
                    <div class="block-content">
                      <div>
                        <!--  electric start -->
                        <div
                          class="block block-bordered col-md-12 block-mode-hidden"
                          v-for="product in Object.keys(formsData.products)"
                          :key="product"
                        >
                          <div class="block-header block-header-default">
                            <h3 class="block-title">
                              {{ product }}(
                              <span
                                style="font-weight: 600; color: #0005a6"
                                :key="formName"
                                v-for="formName in formsData.products[product]
                                  .forms"
                                >{{ formName }},
                              </span>
                              )
                            </h3>
                            <div class="block-options">
                              <button
                                type="button"
                                data-toggle="modal"
                                data-target="#modal-block-add-supplier"
                                class="btn-block-option"
                                @click="
                                  getProducSupplier(
                                    formsData.products[product].id
                                  )
                                "
                              >
                                <i class="fa fa-plus text-primary-dark"></i>
                              </button>
                              <button
                                type="button"
                                class="btn-block-option"
                                data-toggle="block-option"
                                data-action="content_toggle"
                              >
                                <i class="si si-arrow-down"></i>
                              </button>
                            </div>
                          </div>
                          <div class="block-content">
                            <div
                              class="block block-bordered col-md-12"
                              draggable="false"
                              v-for="productSupplier in Object.keys(
                                formsData.products[product].suppliers
                              )"
                              :key="productSupplier"
                            >
                              <!--Supplier Eneco-->
                              <div class="block-header block-header-default">
                                <!---->
                                <h3 class="block-title">
                                  <small>
                                    {{ productSupplier }}
                                  </small>
                                </h3>
                                <!---->
                                <div class="block-options">
                                  <button
                                    type="button"
                                    data-toggle="modal"
                                    data-target="#modal-block-add-supplier"
                                    class="btn-block-option"
                                  ></button>
                                  <button
                                    type="button"
                                    data-toggle="block-option"
                                    data-action="content_toggle"
                                    class="btn-block-option"
                                  >
                                    <i class="si si-arrow-down"></i>
                                  </button>
                                </div>
                              </div>
                              <div class="block-content">
                                <div class="row">
                                  <table
                                    class="js-table-checkable table table-hover table-vcenter js-table-checkable-enabled"
                                  >
                                    <thead>
                                      <tr>
                                        <th
                                          class="text-center"
                                          style="width: 70px"
                                        ></th>
                                        <th width="15%">Aanbieder</th>
                                        <th class="d-sm-table-cell">Pakket</th>
                                        <th
                                          class="text-center d-sm-table-cell"
                                          style="width: 20%"
                                        >
                                          Welkomstpremie
                                        </th>
                                        <th class="text-center d-sm-table-cell">
                                          Per jaar
                                        </th>
                                        <th
                                          width="170px"
                                          class="d-sm-table-cell"
                                        ></th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr
                                        v-for="item in formsData.products[
                                          product
                                        ].suppliers[productSupplier]"
                                        :key="item.id"
                                      >
                                        <td class="text-center">
                                          <div
                                            class="custom-control custom-radio custom-control-primary d-inline-block"
                                          >
                                            <input
                                              type="radio"
                                              id="row60"
                                              name="rowsuppliers"
                                              class="custom-control-input"
                                            /><label
                                              for="row60"
                                              class="custom-control-label"
                                            ></label>
                                          </div>
                                        </td>
                                        <td>
                                          <img
                                            v-if="item.logo"
                                            :src="getImage(item.logo)"
                                            class="img-fluid w-50"
                                          />
                                        </td>
                                        <td class="d-sm-table-cell">
                                          (
                                          <span
                                            v-for="formName in item.forms"
                                            :key="formName"
                                          >
                                            {{
                                              formName ? formName : "null"
                                            }}, </span
                                          >)<br />
                                          <span>{{
                                            parseJSONSupplierName(
                                              item.name,
                                              lang
                                            )
                                          }}</span>
                                        </td>
                                        <td class="text-center d-sm-table-cell">
                                          <p class="font-w600 mb-1">€..</p>
                                          <p class="text-muted mb-0">+...</p>
                                        </td>
                                        <td class="text-center d-sm-table-cell">
                                          €...
                                        </td>
                                        <td>
                                          <button
                                            class="btn btn-danger"
                                            data-bs-toggle="modal"
                                            data-bs-target="#supplierDeleteModal1"
                                            @click="
                                              handleEditSuppliers(
                                                product,
                                                productSupplier,
                                                item
                                              )
                                            "
                                          >
                                            <span
                                              style="color: rgb(255, 255, 255)"
                                            >
                                              <i class="far fa-edit"></i>
                                            </span>
                                          </button>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- end of new editor -->
                </div>
                <!-- start widgets -->
                <div
                  class="block block-bordered col-md-12"
                  style="background-color: #e6fff5"
                >
                  <div
                    class="block-header block-header-default"
                    style="background-color: #e6fff5; font-size: 15px"
                  >
                    <h3 class="block-title">Widgets</h3>
                    <button
                      type="button"
                      data-toggle="modal"
                      data-target="#modal-block-add-widget-form-manager"
                      class="btn btn-outline-success"
                      style="font-size: 10px"
                    >
                      Add Widgets
                    </button>
                    <div class="block-options">
                      <button
                        type="button"
                        class="btn-block-option"
                        data-toggle="block-option"
                        data-action="content_toggle"
                      >
                        <i class="si si-arrow-down"></i>
                      </button>
                    </div>
                  </div>
                  <div class="block-content">
                    <div>
                      <div
                        class="block block-bordered block-mode-hidden"
                        v-for="widget in Object.keys(formsData.widgets)"
                        :key="widget"
                      >
                        <div class="block-header block-header-default">
                          <h3 class="block-title">
                            {{ formsData.widgets[widget].title }} (
                            <span
                              style="font-weight: 600; color: #007736"
                              :key="formName"
                              v-for="formName in formsData.widgets[widget]
                                .forms"
                              >{{ formName }},
                            </span>
                            )
                          </h3>
                          <div class="block-options">
                            <button
                              type="button"
                              data-toggle="modal"
                              data-target="#modal-block-add-supplier"
                              class="btn-block-option"
                            ></button>
                            <button
                              type="button"
                              class="btn-block-option"
                              data-toggle="block-option"
                              data-action="content_toggle"
                            ></button>
                          </div>
                        </div>
                        <div class="block-content"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- end of widgets -->
                <div class="row">
                  <div class="col-3">
                    <button
                      class="btn btn-outline-warning btn-lg btn-block"
                      @click="$router.push('/')"
                    >
                      Dashboard
                    </button>
                  </div>
                  <div class="col-3">
                    <button class="btn btn-outline-info btn-lg btn-block">
                      Save as Draft
                    </button>
                  </div>
                  <div class="col-3">
                    <button class="btn btn-outline-success btn-lg btn-block">
                      Publish
                    </button>
                  </div>
                  <div class="col-3">
                    <button
                      class="btn btn-outline-danger btn-lg btn-block"
                      type="button"
                      data-toggle="modal"
                      data-target="#modal-block-custom-css"
                    >
                      Add Custom Css
                    </button>
                  </div>
                  <div class="clearfix"></div>
                </div>
              </div>
            </main>
          </div>
        </div>
      </div>
    </main>
    <add-connection-form-manager
      :formsData="formsData"
      :selectedForms="selectedForms"
    ></add-connection-form-manager>
    <add-widgets-form-manager
      :formsData="formsData"
      :selectedForms="selectedForms"
    ></add-widgets-form-manager>
    <form-add-modal></form-add-modal>
    <supplier-add-modal from="formManager"></supplier-add-modal>
    <div
      class="modal fade"
      id="supplierDeleteModal1"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Edit Suppliers ({{
                parseJSONSupplierName(selectedSupplier, lang)
              }})
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body" v-if="editSuppliersProduct !== ''">
            <div class="row">
              <div class="col-md-6">
                <h4>Delete from forms</h4>
                <div :key="formName" v-for="formName in deleteFromForms">
                  <input type="checkbox" />
                  (
                  <span>{{ formName }}, </span>
                  )
                </div>
                <br />
              </div>
              <div class="col-md-6">
                <h4>Add to forms</h4>
                <div :key="formName" v-for="formName in addToForms">
                  <input type="checkbox" />
                  (
                  <span>{{ formName }}, </span>
                  )
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Close
            </button>
            <button
              type="button"
              class="btn btn-primary"
              data-bs-dismiss="modal"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import HeaderComponent from "../../components/layout/Header";
import SidebarComponent from "../../components/layout/Sidebar";
import AddConnectionFormManager from "../../components/modals/AddConnectionFormManager";
import AddWidgetsFormManager from "../../components/modals/AddWidgetFormManager";
import FormAddModal from "../../components/modals/FormAddModal";
import { mapActions } from "vuex";
import SupplierAddModal from "../../components/modals/SupplierAddModal.vue";
// import $ from "jquery"
export default {
  name: "formManager2",
  components: {
    SidebarComponent,
    HeaderComponent,
    AddConnectionFormManager,
    AddWidgetsFormManager,
    FormAddModal,
    SupplierAddModal
  },
  data: () => {
    return {
      selectedForms: [],
      searchForms: [],
      isLoading: false,
      isSearchable: true,
      type: "",
      formsData: {
        products: {},
        widgets: {}
      },
      editSuppliersProduct: "",
      deleteFromForms: [],
      addToForms: [],
      selectedSupplier: ""
    };
  },
  computed: {
    ...mapState({
      products: state => state.products.products,
      multipleForms: state => state.forms.multipleForms
    })
  },
  watch: {
    selectedForms(val) {
      this.searchForms = [];
      if (val.length > 0) {
        if (val.length < 5) {
          this.isSearchable = true;
          let ids = "";
          val.map((form, index) => {
            if (index < val.length - 1) {
              ids += form.id + ",";
            } else {
              ids += `${form.id}`;
            }
          });
          this.getMultipleForms(ids).then(() => {
            this.editMultipleForms();
          });
        } else if (val.length === 5) {
          this.isSearchable = false;
          let ids = "";
          val.map((form, index) => {
            if (index < val.length - 1) {
              ids += form.id + ",";
            } else {
              ids += `${form.id}`;
            }
          });
          this.getMultipleForms(ids).then(() => {
            this.editMultipleForms();
          });
          this.isSearchable = false;
        }
      } else {
        this.formsData = {
          products: {},
          widgets: {}
        };
      }
    }
  },
  methods: {
    ...mapActions({
      getProducts: "products/getProducts",
      getMultipleForms: "forms/getMultipleForms",
      searchFormByName: "forms/searchFormByName",
      getSupplier: "suppliers/getSupplier"
    }),
    handleEditSuppliers(product, productSupplier, item) {
      this.selectedSupplier = item.name;
      this.editSuppliersProduct = product;
      this.deleteFromForms = this.formsData.products[product].suppliers[
        productSupplier
      ].filter(x => x.id === item.id)[0].forms;
      let temp = [];
      this.selectedForms.map(form => {
        temp.push(form.name);
      });
      let temp2 = [];
      temp.map(a => {
        if (!this.deleteFromForms.includes(a)) {
          temp2.push(a);
        }
      });
      this.addToForms = temp2;
    },
    handleOnSelect() {
      this.searchForms = [];
    },
    handleFormSearch(event) {
      if (event.length >= 3) {
        this.isLoading = true;
        this.searchFormByName({ key: event, filter: "contract" }).then(res => {
          this.searchForms = res.data.data;
          this.isLoading = false;
        });
      }
    },
    getProducSupplier(id) {
      this.getSupplier(id);
    },
    editMultipleForms() {
      let formsData = {
        products: {},
        suppliers: {},
        widgets: {}
      };
      //Products
      Object.keys(this.multipleForms).map(form => {
        Object.keys(this.multipleForms[form].productIDs).map(productId => {
          if (Object.keys(formsData.products).includes(productId)) {
            formsData.products[productId].forms.push(
              this.multipleForms[form].formName
            );
          } else {
            formsData.products[productId] = {
              id: this.multipleForms[form].productIDs[productId],
              forms: [this.multipleForms[form].formName]
            };
          }
        });
      });
      //Widgets
      Object.keys(this.multipleForms).map(form => {
        if (
          this.multipleForms[form].widgets !== null &&
          this.multipleForms[form].widgets !== undefined
        ) {
          Object.keys(this.multipleForms[form].widgets).map(widget => {
            if (
              Object.keys(formsData.widgets).includes(
                this.namesToObjNames(
                  this.multipleForms[form].widgets[widget].title
                )
              )
            ) {
              if (
                !formsData.widgets[
                  this.namesToObjNames(
                    this.multipleForms[form].widgets[widget].title
                  )
                ].forms.includes(this.multipleForms[form].formName)
              )
                formsData.widgets[
                  this.namesToObjNames(
                    this.multipleForms[form].widgets[widget].title
                  )
                ].forms.push(this.multipleForms[form].formName);
            } else {
              formsData.widgets[
                this.namesToObjNames(
                  this.multipleForms[form].widgets[widget].title
                )
              ] = {
                title: this.multipleForms[form].widgets[widget].title,
                forms: [this.multipleForms[form].formName]
              };
            }
          });
        }
      });
      let temp = {};
      //Suppliers
      Object.keys(this.multipleForms).map(form => {
        temp[form] = {};
        temp[form].suppliers = {};
        if (this.multipleForms[form].suppliersIDs) {
          Object.keys(this.multipleForms[form].suppliersIDs).map(
            supplierProduct => {
              temp[form].suppliers[supplierProduct] = {};
              this.multipleForms[form].suppliersIDs[supplierProduct].map(a => {
                temp[form].suppliers[supplierProduct][
                  Object.keys(a)[0]
                ] = Object.values(a)[0];
                // console.log(Object.keys(a)[0])
              });
            }
          );
        }
      });
      let suppliersByForms = {};
      Object.keys(temp).map(form => {
        Object.keys(temp[form].suppliers).map(supplierProduct => {
          if (!Object.keys(suppliersByForms).includes(supplierProduct)) {
            suppliersByForms[supplierProduct] = {};
          }
          Object.keys(temp[form].suppliers[supplierProduct]).map(supplier => {
            if (
              Object.keys(suppliersByForms[supplierProduct]).includes(supplier)
            ) {
              suppliersByForms[supplierProduct][supplier].forms.push(
                this.multipleForms[form].formName
              );
            } else {
              suppliersByForms[supplierProduct][supplier] = {
                ...temp[form].suppliers[supplierProduct][supplier],
                forms: [this.multipleForms[form].formName],
                id: supplier
              };
            }
          });
        });
      });
      let suppliersGrouped = {};
      Object.keys(suppliersByForms).map(supplierProduct => {
        suppliersGrouped[supplierProduct] = [];
        Object.keys(suppliersByForms[supplierProduct]).map(supplier => {
          suppliersGrouped[supplierProduct].push(
            suppliersByForms[supplierProduct][supplier]
          );
        });
        suppliersGrouped[supplierProduct] = this.groupBy(
          suppliersGrouped[supplierProduct],
          "supplier_name"
        );
      });
      Object.keys(formsData.products).map(product => {
        if (Object.keys(suppliersGrouped).includes(product)) {
          let temp = {};
          Object.keys(suppliersGrouped[product]).map(name => {
            let newName = this.namesToObjNames(name);
            temp[newName] = suppliersGrouped[product][name];
          });
          formsData.products[product].suppliers = temp;
        } else {
          formsData.products[product].suppliers = {};
        }
      });
      // console.log(suppliersByForms)
      this.formsData = formsData;
      this.$forceUpdate();
    },
    namesToObjNames(name) {
      let wordArray = name.split(" ");
      let name2 = "";
      wordArray.map(word => {
        let a = word;
        a = a.substr(0, 1).toUpperCase() + a.substr(1);
        name2 += a;
      });
      return name2;
    },
    parseJSONSupplierName(text, language) {
      try {
        return JSON.parse(text)[language];
      } catch (e) {
        return text;
      }
    }
  },
  mounted() {
    this.$store.state.forms.formStateData.data = {};
    this.$store.state.forms.formStateData.data.fields = [];
    //  this.searchKey = window.location.search
    //     .split("&")
    //     .filter(x => x.includes("ids"))[0]
    //     .split("=")[1];
    //     var url = new URL(window.location.href);
    //     var ids = url.searchParams.get("ids");
    //     this.getMultipleForms(ids).then(() => {
    //       this.editMultipleForms()
    //     })
    //     $(function() {
    //       $('.selectpicker').selectpicker();
    //     });
    // this.selectedForms = JSON.parse(localStorage.getItem("selectedForms"));
  },
  beforeMount() {
    this.getProducts();
  }
};
</script>
<style scoped>
.utility img {
  max-width: 40px;
  display: block;
  margin: 0 auto;
  margin-top: 25px;
}
.utility input {
  display: none;
}
.utility div {
  display: block;
  position: relative;
  border: 1px solid #a0a0a0;
  text-align: center;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  height: 160px;
  cursor: pointer;
  transition: background-color 0.2s, box-shadow 0.2s;
}
.utility .more {
  width: 100%;
  background: #f5fbfd;
  display: block;
  text-align: center;
  color: #1678aa;
  padding: 10px;
  position: absolute;
  bottom: 0;
  left: 0;
  font-weight: normal;
  font-size: 14px;
}
@media only screen and (max-width: 600px) {
  .situation {
  }
  .familyImage {
    display: none;
  }
  .familyLabel {
    height: 50px;
  }
  .familySpan {
  }
}
@media only screen and (min-width: 601px) {
  .situation {
    display: flex;
    justify-content: space-between;
  }
  .familyItems {
    flex: 0.18;
  }
  .familyLabel {
    height: 130px;
  }
  .familySpan {
    display: flex;
    align-self: center;
    flex-direction: column;
    margin-top: 40%;
  }
}
</style>
